module.exports = __webpack_public_path__ + "fonts/SourceHanSans-Normal.a98ad819.otf";